/**
 * navigationGuardStore.ts — Store Zustand para la guardia de navegación.
 *
 * QUÉ HACE:
 * - Mantiene el estado del modal de confirmación de salida con carrito lleno
 * - Vive fuera de CajaPage (en MainLayout) para que no se desmonte con la página
 * - El singleton navigationGuard lo actualiza cuando hay una navegación bloqueada
 *
 * QUÉ EXPORTA: useNavigationGuardStore
 *
 * QUÉ NO DEBE HACER:
 * - No debe gestionar lógica de rutas ni carritos
 */

import { create } from "zustand";

interface NavigationGuardState {
  isBlocked: boolean;
  pendingAction: (() => void) | null;
  block: (proceed: () => void) => void;
  confirm: () => void;
  cancel: () => void;
}

export const useNavigationGuardStore = create<NavigationGuardState>(
  (set, get) => ({
    isBlocked: false,
    pendingAction: null,

    block: (proceed) => set({ isBlocked: true, pendingAction: proceed }),

    confirm: () => {
      const action = get().pendingAction;
      set({ isBlocked: false, pendingAction: null });
      action?.();
    },

    cancel: () => set({ isBlocked: false, pendingAction: null }),
  }),
);
